import { Injectable } from '@angular/core';

import { modules } from '../commons/config';

@Injectable()
export class ModuleService {

    constructor() {
      //why is it empty?
     }

    private modulesConst = modules;
    private mfaChecked:boolean = false;
    private password:string;
    private username:string;
    private phone:string;

    getModulesCache(): Array<any> {
        return JSON.parse(localStorage.getItem('modules'));
    }

    getLocalResourcesDisabled(): boolean {
        return !!!JSON.parse(localStorage.getItem('disableLocalResources'));
    }
    getHelpLineDisabled(): boolean {
        return !!!JSON.parse(localStorage.getItem('disableHelpLine'));
    }

    getModule(moduleRequested: any): boolean {
        const modules = this.getModulesCache();
        if (modules) {
            return !!(modules.filter(module => module === moduleRequested).length);
        }
    }


    setUsername(username) {
        this.username = username;
    }
    getUsername() {
        return this.username;
    }

    setPassword(password) {
        this.password = password;
    }

    getPassword(){
        return this.password;
    }

    isMfaAlreadyChecked(): boolean {
        return this.mfaChecked;
    }

    setMfaAlreadyChecked(status:boolean){
      this.mfaChecked = status;
    }

    setPhone(phone) {
      this.phone=phone;
    }

    getPhone() {
      return this.phone;
    }

    isRegistryAvailable(): boolean {
        return this.getModule(this.modulesConst.REGISTRY);
    }

    isBlogAvailable(): boolean {
        return this.getModule(this.modulesConst.BLOG);
    }

    isLocalResourcesAvailable(): boolean {
        return (this.getModule(this.modulesConst.LOCAL_RESOURCES) && this.getLocalResourcesDisabled());
    }

    isHelpLineAvailable(): boolean {
        return (this.getModule(this.modulesConst.HELP_LINE) && this.getHelpLineDisabled());
    }

    isLivingCancerAvailable(): boolean {
        return this.getModule(this.modulesConst.LIVING_CANCER);
    }

    isAboutIoAvailable(): boolean {
        return this.getModule(this.modulesConst.ABOUT_IO);
    }

    isCustomSurveysAvailable(): boolean {
        return this.getModule(this.modulesConst.CUSTOM_SURVEYS);
    }
}
